<template>
  <div>
    <Card>
      <Row style="margin: 0">
        <Col span="24">
          <Row>
            <Col span="6" class="bold">服务单号</Col>
            <Col span="18" class="wb-all"
              >{{ so_no }}（{{ so_serail_no }}）</Col
            >
          </Row>
          <Row v-if="data.SO_WARRANTY_DATE != ''">
            <Col span="6" class="bold">保修期限</Col>
            <Col span="18"
              >{{ so_warrant_date }}
              <font-awesome-icon
                icon="exclamation-circle"
                size="1g"
                :style="{ color: '#ff5722' }"
                @click="warrantyMsg"
                v-if="data.SO_IS_SHOW_WARRANTY_TIPS == true"
              />
              <a style="margin-left: 5px" @click="renewpost">续订</a>
            </Col>
          </Row>
          <Row>
            <Col span="6" class="bold">机器型号</Col>
            <Col span="14" class="wb-all">{{ so_product }}</Col>
            <Col span="4">
              <div
                v-if="data.SO_STATUS === 'O'"
                class="circle-btn bg-dell-primary fr"
                @click="popupDesc"
                style="margin-top: -10px"
                :class="so_problem.feedback ? 'feedback-button' : ''"
              >
                <a>
                  <img class="vm" width="18" src="@/assets/images/edit.png" />
                </a>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span="6" class="bold">预约时间</Col>
            <Col span="18">
              <div v-if="!booking">
                <span style="vertical-align: top" class="mr-2"
                  >{{ so_booking.date4Show }} {{ so_booking.time4Show }}</span
                >
                <span class="status">{{ so_tips_center }}</span>
                <div
                  v-if="bookingButton"
                  class="circle-btn fr bg-dell-primary"
                  @click="popupBooking()"
                >
                  <a>
                    <img
                      class="vm"
                      width="20"
                      src="@/assets/images/clock.png"
                    />
                  </a>
                </div>
              </div>
              <i-form
                ref="formBookTime"
                :model="formBookTime"
                :rules="ruleBookTime"
                inline
                v-else
              >
                <Form-item
                  prop="date"
                  style="margin-bottom: 16px; margin-right: 5px"
                >
                  <Select
                    size="large"
                    style="width: 110px"
                    v-model="formBookTime.date"
                  >
                    <Option
                      v-for="item in so_workdays"
                      :value="item"
                      :key="item"
                      >{{ item }}</Option
                    >
                  </Select>
                </Form-item>
                <!-- <Form-item prop="time" style="margin-bottom: 16px;margin-right:5px;">
                  <Select size="large" style="width:50px" v-model="formBookTime.hour">
                    <Option v-for="item in so_workhour" :value="item" :key="item">{{item}}</Option>
                  </Select>
                </Form-item>-->
                <Form-item
                  prop="time"
                  style="margin-bottom: 16px; margin-right: 0"
                >
                  <Select
                    size="large"
                    style="width: 110px"
                    v-model="formBookTime.second"
                  >
                    <Option
                      v-for="item in so_worksecond"
                      :value="item"
                      :key="item"
                      >{{ item }}</Option
                    >
                  </Select>
                </Form-item>
                <Form-item>
                  <Button
                    type="text"
                    class="txt-dell-primary"
                    @click="popupBooking('formBookTime')"
                  >
                    <span>保存</span>
                  </Button>
                  <!-- 确定保存预约信息弹窗 -->
                  <Modal class="reConfirmBox" v-model="modal6">
                    <div slot="header">
                      <font-awesome-icon
                        icon="question-circle"
                        :style="{ color: '#ff9900' }"
                        size="lg"
                      />
                      <label style="margin-left: 10px; font-weight: bold"
                        >修改预约</label
                      >
                    </div>
                    <div class="content-text">
                      确认改约到( {{ formBookTime.date }}
                      {{ formBookTime.second }} ) 吗？
                    </div>
                    <div slot="footer">
                      <Button
                        type="primary"
                        size="large"
                        @click="reConfirm(true)"
                        >确定</Button
                      >
                      <Button type="text" size="large" @click="reConfirm(false)"
                        >取消</Button
                      >
                    </div>
                  </Modal>
                  <Button
                    type="text"
                    class="txt-dell-primary ml-1"
                    @click="popupBooking()"
                  >
                    <span>取消</span>
                  </Button>
                </Form-item>
              </i-form>
            </Col>
          </Row>
          <Row>
            <Col span="6" class="bold">服务状态</Col>
            <Col span="18">{{ so_status_name }}</Col>
          </Row>
          <Row v-if="so_tips">
            <Col span="6" class="bold">温馨提示</Col>
            <Col span="18">{{ so_tips }}</Col>
          </Row>
        </Col>
      </Row>
    </Card>
    <Card class="mt-2" v-if="data.SO_STATUS === 'X' || data.SO_STATUS === 'C'">
      <Row>
        <Col span="6" class="bold">意见反馈</Col>
        <Col span="18">
          <p v-if="data.SO_IS_FEEDBACK">{{ so_feedback }}</p>
          <Input v-else type="textarea" v-model="so_feedback" />
        </Col>
      </Row>
      <Row class="ivu-row-flex ivu-row-flex-middle">
        <Col span="6" class="bold pt-1">服务评分</Col>
        <Col span="12">
          <Rate
            v-model="so_score"
            icon="ios-heart"
            :disabled="data.SO_IS_FEEDBACK"
          />
        </Col>
        <Col span="6" v-if="!data.SO_IS_FEEDBACK">
          <Button
            type="text"
            class="txt-dell-primary"
            size="large"
            long
            @click="saveFeedback"
            >提交</Button
          >
        </Col>
      </Row>
    </Card>
    <!-- 问题描述补充 -->
    <Modal v-model="so_problem.popup" title="问题描述补充">
      <Row>
        <Col span="24">
          <Input
            type="textarea"
            v-model="so_problem.feedback"
            :rows="6"
            :maxlength="500"
          />
        </Col>
      </Row>
      <Row slot="footer">
        <Col span="24">
          <Button
            type="text"
            class="txt-dell-primary"
            size="large"
            @click="closeModal"
            >取消</Button
          >
          <Button
            type="text"
            class="txt-dell-primary"
            size="large"
            @click="saveDesc"
            >提交</Button
          >
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import { formatDate, getToken } from "@/assets/js/Util";
import qs from "qs";

const TIPS = "本页面只用于查看显示信息，请不要实际操作。";

export default {
  props: ["data"],
  data() {
    // let workHour = (function() {
    //   let arr = []
    //   for (var i = 9; i < 19; i++) {
    //     if (i < 10) {
    //       arr.push('0' + i)
    //     } else {
    //       arr.push(i)
    //     }
    //   }
    //   return arr
    // })()
    let workSecond = [
      "08:00-10:00",
      "10:00-12:00",
      "12:00-14:00",
      "14:00-16:00",
      "16:00-18:00",
    ];
    return {
      modal6: false,
      so_no: "",
      so_no_des: "",
      so_serail_no: "",
      so_product: "",
      confirmCode: false,
      so_booking: {
        date4Show: "",
        date4Edit: "",
        time4Show: "",
        time4Edit: "",
        popup: false,
        options: {
          // 禁用日期
          disabledDate: (date) => {
            return !(this.so_workday.indexOf(formatDate(date)) > -1);
          },
        },
      },
      so_tips_center: "",
      so_problem: {
        desc: "",
        feedback: "",
        popup: false,
      },
      so_feedback: "",
      so_tips: "",
      so_score: 0,
      so_workday: [],
      // so_workhour: workHour,
      so_worksecond: workSecond,
      so_support_phone: "",
      so_workdays: "",
      so_status_name: "",
      so_warrant_date: "",
      so_warrant_tips: "",
      so_show_war_tip: false,
      formBookTime: {
        date: "",
        // hour: workHour[0],
        second: workSecond[0],
      },
      ruleBookTime: {
        date: [{ required: true, message: "请填写预约日期", trigger: "blur" }],
        // hour: [{ required: true, message: '请填写预约时间', trigger: 'blur' }],
        second: [
          { required: true, message: "请填写预约时间", trigger: "blur" },
        ],
      },
      booking: false, // trur:显示日期时间选择框
      bookingButton: false, // true:有回拨客服按钮，false：没有
      so_renew_link: "",
    };
  },
  computed: {
    canSubmit() {
      return this.data.Source !== "Admin";
    },
  },
  watch: {
    data(newV, oldV) {
      console.log("newV0", newV);
      this.so_no = newV.SO_NO;
      this.so_no_des = newV.SO_NO_DES; // 加密 so
      this.so_serail_no = newV.SO_SERAIL_NO;
      this.so_product = this.sliceWithComma(newV.SO_PRODUCT);
      this.so_tips_center = newV.SO_TIPS_CENTER;
      this.so_status_name = newV.SO_STATUS_NAME;
      this.so_warrant_date = newV.SO_WARRANTY_DATE;
      this.so_warrant_tips = newV.SO_WARRANTY_TIPS;
      this.so_show_war_tip = newV.SO_IS_SHOW_WARRANTY_TIPS;
      this.so_renew_link = newV.SO_RENEW_LINK;
      // 改约时间（编辑与现实分开）
      if (newV.SO_BOOKING_TIME) {
        // console.log('获取的时间值',newV.SO_BOOKING_TIME)
        let datetime = newV.SO_BOOKING_TIME.split(" ");
        if (datetime[1].length <= 5) {
          let dateHour = parseInt(datetime[1].split(":")[0]) - 2;
          let dateHourBegin =
            dateHour < 0 ? "00" : dateHour > 9 ? dateHour : "0" + dateHour;
          this.so_booking.time4Show =
            dateHourBegin + ":" + datetime[1].split(":")[1] + "-" + datetime[1];
        } else {
          this.so_booking.time4Show = datetime[1];
        }
        // console.log('datetime-切割的', datetime)
        this.so_booking.date4Show = datetime[0];
        this.so_booking.date4Edit = datetime[0];

        // this.so_booking.time4Show = datetime[1]
        this.so_booking.time4Edit = datetime[1];
      }

      // 问题描述补充（编辑与现实分开）
      this.so_problem.desc = newV.SO_PROBLEM_DESCRIPTION;
      this.so_problem.feedback = newV.SO_PROBLEM_FEEDBACK;

      this.so_support_phone = newV.SO_SUPPORT_PHONE;

      this.so_tips = newV.SO_TIPS;
      this.so_workday = newV.SO_WORKDAY;

      this.so_workdays = newV.SO_WORKDAYS ? newV.SO_WORKDAYS : [];
      this.formBookTime.date = newV.SO_WORKDAYS[0];
      this.bookingButton =
        newV.SO_STATUS === "O" && newV.SO_IS_SD && this.so_workdays.length > 0; // so_is_sd:true代表可以改约
      this.so_score = parseInt(newV.SO_SCORE, 10);
      this.so_feedback = newV.SO_FEEDBACK;
    },
  },
  methods: {
    reConfirm(type) {
      if (type) {
        this.$refs["formBookTime"].validate((valid) => {
          if (valid) {
            // console.log('formBookTime', this.formBookTime)
            // console.log('data', this.data)
            this.postData(
              "so_booking_time",
              {
                so_no: this.so_no_des,
                so_schedule_date:
                  this.formBookTime.date +
                  " " +
                  // this.formBookTime.hour +
                  // ':' +
                  this.formBookTime.second,
                so_last_change_time: this.data.SO_LAST_CHANGE_TIME,
              },
              (data) => {
                if (data.CODE === "OK") {
                  this.$Modal.info({
                    content: `请留意此页信息或客服来电 (或短信) 以确认改约时间；如您是在非工作时间提出的申请，我们会在工作时间与您尽快确认，敬请谅解！`,
                    // content: `请留意此页信息或客服来电以确认改约时间`,
                    onOk: function () {
                      location.reload();
                    },
                  });
                } else {
                  this.$Modal.info({
                    content: data.MSG,
                    onOk: function () {
                      if (data.ERR_CODE === "E0") {
                        location.reload();
                      }
                    },
                  });
                }
              }
            );
          }
        });
      } else {
        this.modal6 = false;
      }
    },
    popupBooking(name) {
      // console.log(name)
      if (this.canSubmit) {
        if (name) {
          if (name.toString() === "formBookTime") {
            // console.log(11)
            this.modal6 = true;
            // this.$Modal.confirm({
            // // title: '预约',
            //   content: '<p>确认预约吗？</p>',
            //   onOk: () => {
            //     this.aaaa()

            //   },
            //   onCancel: () => {
            //     this.confirmCode = false
            //   // this.$Message.info('Clicked cancel')
            //   }
            // })
          }
          // this.$Modal.confirm({
          //   // title: '预约',
          //   content: '<p>确认预约吗？</p>',
          //   onOk: () => {
          //     this.aaaa()
          //   },
          //   onCancel: () => {
          //     this.confirmCode = false
          //     // this.$Message.info('Clicked cancel')
          //   }
          // })
          // console.log(this.$Modal.confirm)
          // if (this.confirmCode) {
          //   this.$refs[name].validate(valid => {
          //     if (valid) {
          //       // console.log('formBookTime', this.formBookTime)
          //       // console.log('data', this.data)
          //       this.postData(
          //         'so_booking_time',
          //         {
          //           so_no: this.so_no_des,
          //           so_schedule_date:
          //             this.formBookTime.date +
          //             ' ' +
          //             // this.formBookTime.hour +
          //             // ':' +
          //             this.formBookTime.second,
          //           so_last_change_time: this.data.SO_LAST_CHANGE_TIME
          //         },
          //         data => {
          //           if (data.CODE === 'OK') {
          //             this.$Modal.info({
          //               content: `请留意此页信息或客服来电 (或短信) 以确认改约时间；如您是在非工作时间提出的申请，我们会在工作时间与您尽快确认，敬请谅解！`,
          //               // content: `请留意此页信息或客服来电以确认改约时间`,
          //               onOk: function() {
          //                 location.reload()
          //               }
          //             })
          //           } else {
          //             this.$Modal.info({
          //               content: data.MSG,
          //               onOk: function() {
          //                 if (data.ERR_CODE === 'E0') {
          //                   location.reload()
          //                 }
          //               }
          //             })
          //           }
          //         }
          //       )
          //     }
          //   })
          // }
        } else {
          this.booking = !this.booking;
        }
      } else {
        this.$Message.warning({ content: TIPS });
      }
    },
    popupDesc() {
      this.so_problem.popup = true;
    },
    closeModal() {
      this.so_problem.popup = false;
    },
    saveDesc() {
      if (this.canSubmit) {
        this.postData(
          "so_problem_description",
          {
            so_no: this.so_no_des,
            so_problem_description: this.so_problem.feedback,
            so_last_change_time: this.data.SO_LAST_CHANGE_TIME,
          },
          (data) => {
            if (data.CODE === "OK") {
              this.$Message.success("保存成功");
              /* location.reload(); */
            } else {
              this.$Modal.info({
                content: data.MSG,
                onOk: function () {
                  if (data.ERR_CODE === "E0") {
                    location.reload();
                  }
                },
              });
            }
            this.closeModal();
          }
        );
      } else {
        this.$Message.warning({ content: TIPS });
      }
    },
    saveFeedback() {
      if (this.canSubmit) {
        if (this.so_score === 0) {
          this.$Modal.info({
            content: "请写下您对我们服务的评价！",
          });
          return;
        }
        if (/^\s*$/.test(this.so_feedback) && this.so_score !== 5) {
          this.$Modal.info({
            content: "请写下您对我们服务的评价！",
          });
          return;
        }
        this.postData(
          "so_feedback",
          {
            so_no: this.so_no_des,
            so_feedback: this.so_feedback,
            so_score: this.so_score,
            so_last_change_time: this.data.SO_LAST_CHANGE_TIME,
          },
          (data) => {
            if (data.CODE === "OK") {
              this.$Modal.info({
                content: "谢谢您对我们服务的支持！",
              });
              this.$emit("changeSubmitStatus");
            } else {
              this.$Modal.info({
                content: data.MSG,
              });
            }
          }
        );
      } else {
        this.$Message.warning({ content: TIPS });
      }
    },
    postData(type, data, callback) {
      getToken((token) => {
        this.$http
          .post(
            process.env.VUE_APP_API,
            qs.stringify({
              type,
              data: JSON.stringify(data),
              token,
            })
          )
          .then((resp) => {
            let data = resp.data;
            if (resp.status === 200 && resp.ERR_CODE !== 0) {
              callback(data);
            }
          })
          .catch((err) => {
            this.$Message.error({ content: err });
          });
      });
    },
    // 以逗号作为分隔，有逗号截取逗号前的内容，否则原字符串返回
    sliceWithComma(str) {
      // console.log("当前", str)
      const index = str.indexOf(",");
      if (index) {
        return str.slice(0, index);
      } else {
        return str;
      }
    },
    //续订
    renewpost() {
      console.log("renewpost...");
      this.postData("so_click_renew_link", { so_no: this.so_no }, (data) => {
        console.log(data);
        window.open(this.so_renew_link);
      });
    },
    //到保日期提醒
    warrantyMsg() {
      console.log("click.warranty..", this.so_no);
      localStorage.setItem("renew_so", this.so_no);
      localStorage.setItem("renew_link", this.so_renew_link);
      this.postData("so_click_warranty_tips", { so_no: this.so_no }, (data) => {
        console.log(data);
      });
      this.$Modal.confirm({
        content: `${this.so_warrant_tips}`,
        onOk: function () {
          let sono = localStorage.getItem("renew_so");
          let renewlink = localStorage.getItem("renew_link");
          console.log("renew_so...", sono, renewlink);
          //提交
          let type = "so_click_renew_link";
          let data = { so_no: sono };
          getToken((token) => {
            this.$http
              .post(
                process.env.VUE_APP_API,
                qs.stringify({
                  type,
                  data: JSON.stringify(data),
                  token,
                })
              )
              .then((resp) => {
                let data = resp.data;
                console.log('postrenew_res',data);
                if (resp.status === 200 && resp.ERR_CODE !== 0) {
                  //callback(data); //跳转
                  localStorage.removeItem("renew_so");
                  localStorage.removeItem("renew_link");
                  window.open(renewlink);
                }
              })
              .catch((err) => {
                this.$Message.error({ content: err });
              });
          });

          //this.renewpost();
          //提交
        },
        okText: "续订",
      });
    },
  },
};
</script>



<style scoped lang="scss">
.f1 {
  color: "red";
}
.feedback {
  height: 22px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.feedback-button {
  float: right;
  margin-left: 2px;
}

.status {
  color: #24b76d;
  font-weight: bold;
  font-size: 16px;
}
.content-text {
  font-size: 14px;
}
.reConfirmBox {
  /deep/.ivu-modal-header {
    border-bottom: none;
    // padding: 5px 16px;
    .ivu-modal-header-inner {
      color: #444;
    }
  }
  /deep/ p {
    font-size: 16px;
    font-weight: 700;
  }
  /deep/ .ivu-modal-footer {
    border-top: none;
    padding: 0px 15px 10px 15px;
  }

  .icononw {
    padding: 2px 5px 0;
    color: #ff5722;
    font-size: 5px;
    background: #fff7f5;
    border-radius: 15px;
    border: 1px solid #ff5722;
  }
}
</style>
